import { DesktopMainFrame } from "@/desktop/components/DesktopMainFrame";
import { Typography } from "@mui/material";

export function DesktopNotesPage() {
    return <DesktopMainFrame>
        <Typography>
            DesktopNotesPage
        </Typography>
    </DesktopMainFrame>;
}